<div class='container py-5'>
  <div class='d-flex flex-column Partners_wrapper'>
    <div class='flex-grow-1 Partners_wrapper_info'>
      <h2 class='text-center'>Partners</h2>
      <p class='text-center'>Interested in being a <span>Retreva partner</span>? We would love to learn more about you.
      </p>
    </div>
    <div class='flex-grow-1 mt-5'>
      <div class='row Partners_wrapper_refereal'>
        <div class='col col-12 col-lg-8 Partners_wrapper_refereal_contest'>
          <h2>Referral Program</h2>
          <div class='Partners_wrapper_refereal_contest_body'>
            <div class='form-all' role='main'>
              <ul class='form-section page-section'>
                <li class='form-line' data-type='control_text' id='id_1'>
                  <div class='form-input-wide' id='cid_1'>
                    <div class='form-html' data-component='text' id='text_1'>
                      <p><span style='font-size: 32px; font-weight:bold'><strong>Retreva Loves Referrals</strong></span>
                      </p>
                      <p></p>
                      <p>Put our Referral Program to work for you. It is super easy. Just click on the Register Referral
                        Link in Retreva. We ask that you have mentioned Retreva to them. We will reach out. If they sign
                        up you will receive a $100.00 Amazon Card for every user sign up. </p>
                      <p>Retreva works well for any business to business sales professional</p>
                      <p>Email <a class='' href='mailto:sales@click2sell.com' rel='nofollow'>sales@click2sell.com</a>
                        with any questions regarding our referral program!</p>
                      <p></p>
                    </div>
                  </div>
                </li>
                <li class='form-line' data-type='control_text' id='id_2'>
                  <div class='form-input-wide' id='cid_2'>
                    <div class='form-html' data-component='text' id='text_2'>
                      <p><span
                        style='font-size: 32px; font-weight:bold'><strong>Retreva is considering Franchising</strong></span>
                      </p>
                      <p></p>
                      <p>We have the privledge of working with some of the biggest and best franchised businesses. Some
                        of our clients have suggested that franchising Retreva would be a good idea and we agree! We are
                        looking for individuals who are passionate about sales and want to own thier own business to
                        help us trial our franchise concept. If you are interested, please email <a
                          href='mailto:sales@click2sell.com' rel='nofollow' target='_blank'>sales@click2sell.com</a>. We
                        want to learn more about you!</p>
                      <p></p>
                      <p></p>
                      <p></p>
                      <p></p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class='col col-12 col-lg-4 Partners_wrapper_refereal_schedule'>
          <h2 class='text-center'>Current Contests</h2>
          <div class='Partners_wrapper_refereal_schedule_body'>
            <div class='main'>
              <ul class='list-unstyled'>
                <li>
                  <div class='form-input-wide' id='cid_3'>
                    <div class='form-html' data-component='text' id='text_3'>
                      <p><strong>Everyday is a good day to add contacts</strong></p>
                      <p>Retreva rewards our customers when they add contacts. We are watching you! It is so important
                        that you add contacts. We gift prizes and contact credits for good contact and inbox behavior.
                        Keep adding those contacts and keep a clean inbox and you just may win a prize!</p>
                      <p><strong>Retreva is Looking for Video Testimonials</strong></p>
                      <p>We know our customers are creative and we want to see it. Retreva is looking for short video
                        testimonials. This can be just you or your entire team. We are looking for fun videos that
                        highlight why you use Retreva, what you love about it and most important how it helps you set
                        meetings, keep in touch with thousands of prospects and sell more. We cannot wait to see what
                        you come up with.</p>
                      <p><strong>You will be rewarded:</strong></p>
                      <ul>
                        <li>
                          Submit a Video and receive a $100.00 Gift Card
                        </li>
                        <li>
                          Up to three winners will receive a $500.00 Gift Card
                        </li>
                      </ul>
                      <p><strong>Email <a href='mailto:help@retreva.com' rel='nofollow'>help@retreva.com</a> with
                        any questions about our contests!</strong></p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class='d-flex Partners_wrapper_highlights'>
  <div class='container d-flex flex-row'>
    <div class='flex-grow-1 d-flex w-100 justify-content-center flex-column'>
      <h2>
        <span>Partners Highlights</span>
      </h2>
      <ul>
        <li>Add the most effective business to business sales tool to your existing offering</li>
        <li>Partners are paid commissions for each user sold and ancillary services like contact sales</li>
        <li>Retreva does all of the training, support and content development</li>
        <li>Start selling Retreva tomorrow!</li>
        <li>White label and branded opportunities available</li>
      </ul>
      <app-button [color]="'blue'" [route]="'/contact_us'" [text]="'Contact us'"></app-button>
    </div>
    <div class='flex-grow-1 d-flex w-100 justify-content-center'>
      <img alt='' class='ms-5' src='assets/images/retail/partners-icon.png'>
    </div>

  </div>
</div>
